import EventBus from './eventbus'
// import Store from './store'

export default class EventListener {
  static showSearchListener(callback) {
    EventBus.$on('showSearch', callback)
  }
  static hideSearchListener(callback) {
    EventBus.$on('hideSearch', callback)
  }
  static menuToggleListener(callback) {
    EventBus.$on('toggleMenu', callback)
  }
}



// WEBPACK FOOTER //
// ./sportspower/assets/es6/eventlistener.js